export const formatDate = date => {
  const dateFormatted = new Date(date).toLocaleDateString('pt-BR')
  return dateFormatted.replace(/^(\d{1})\/(\d{2})/, '0$1/$2')
}
